const defaultState = {
    uploadLoading: false,
    uploadSuccess:false,
    uploadError:false,
    uploadProgress: 0, // Real upload progress (0-100)
};


const uploadReducer = (
    state = defaultState,
    action
) => {
    switch (action.type) {
        case 'SET_UPLOAD_LOADING':
            state = {
                ...state,
                uploadLoading: true,
                uploadProgress: 0
            }
            break;
        case 'UPDATE_UPLOAD_PROGRESS':
            state = {
                ...state,
                uploadProgress: action.payload
            }
            break;
        case 'GET_UPLOAD_SUCCESS' : 
            state ={
                ...state,
                uploadSuccess:true,
                uploadLoading:false,
                uploadProgress: 100
            }
            break;
        case 'GET_UPLOAD_FAILURE' : 
        state ={
                ...state,
                uploadSuccess:false,
                uploadLoading:false,
                uploadError:true,
                uploadProgress: 0
            }
            break;
        case 'SET_ERROR_FALSE':
            state ={
                ...state,
                uploadSuccess:false,
                uploadLoading:false,
                uploadError:false,
                uploadProgress: 0
            }
            break;
        
        
        
        }
         return state;
}

export default uploadReducer